<template>
  <div>
    <Admin_list/>
  </div>
</template>

<script>
import Admin_list from "@/components/adminArin/admin_overall/Admin_list";
export default {
  name: "AdminList",
  components: {
    Admin_list
  }
}
</script>

<style scoped>

</style>
